<template>
  <transition name="fade">
    <div class="dates__row" :class="{ dates__row_online: isOnline }">
      <div class="dates__col dates__col--course">
        <small class="dates__label">{{ $t('course') }}</small>
        <img
          v-if="icon"
          class="attachment file"
          :src="icon"
          :alt="name"
        >
        <div class="dates__text">
          <a :href="url">{{ name }}</a>
        </div>
      </div>
      <div class="dates__col dates__col--date" v-if="!isOnline">
        <small class="dates__label">{{ $t('term') }}</small>
        <div class="dates__text dates__date">
          {{ date_from | date }}
        </div>
        <small class="dates__day">{{ date_from | dayName }}</small>
      </div>
      <div class="dates__col dates__col--place">
        <div class="dates__label">
          {{ $t('place') }}
        </div>
        <div class="dates__text">
          <span v-if="event_type === 'both'">
            <a
              href="/online-kurzy-virtual-training-vs-elearning"
              target="_blank"
              class="virtual-link"
            >{{ $t('virtual') }}</a>
            <span class="virtual-divider">{{ $t('or') }}</span> <span>{{ place }}</span>
          </span>
          <span v-else-if="event_type === 'virtual'">
            <a
              href="/online-kurzy-virtual-training-vs-elearning"
              target="_blank"
              class="virtual-link"
            >{{ $t('virtual') }}
            </a>
          </span>
          <span v-else>{{ place }}</span>
        </div>
      </div>
      <div class="dates__col dates__col--duration" v-if="!isOnline">
        <div class="dates__label">
          {{ $t('duration') }}
        </div>
        <div class="dates__text">
          {{ duration }} {{ isHours ? inflectedHours : inflectedDays }}
        </div>
      </div>
      <div class="dates__col dates__col--language">
        <div class="dates__label">
          {{ $t('language') }}
        </div>
        <div class="dates__text">
          {{ $t(`language_translation.${language}`) }}
        </div>
      </div>
      <div class="dates__col dates__col--price">
        <div class="dates__label">
          {{ $t('price_without_vat') }}
        </div>
        <div class="dates__text dates__text--price">
          {{ price | currency }}
        </div>
        <small><strike>{{ price_old | currency }}</strike></small>
      </div>
      <div class="dates__col dates__col--cta">
        <a
          class="btn-red"
          :href="orderLink"
        >{{ $t('i_am_interested') }}</a>
        <br>
        <small class="dates__cta-alternative">
          <a :href="repaymentsLink">{{ $t('repayments') }}</a>
        </small>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { inflection } from '../lib/inflection';

export default {
  name: 'CourseEvent',
  props: [
    'date_from',
    'duration',
    'duration_unit',
    'event_type',
    'icon',
    'id',
    'language',
    'name',
    'kind',
    'place',
    'price',
    'price_old',
    'url',
  ],

  computed: {
    ...mapGetters({
    }),
    inflectedDays() {
      return inflection(this.duration, Object.values(this.$t('days_duration')));
    },
    inflectedHours() {
      return inflection(this.duration, Object.values(this.$t('hours_duration')));
    },
    isHours() {
      return this.duration_unit === 'hours';
    },
    isVirtual() {
      return this.event_type !== 'in_person';
    },
    orderLink() {
      const virtual = this.isVirtual ? '&virtual=true' : '';
      return `/objednavky/set_event_session?event_id=${this.id}${virtual}`;
    },
    repaymentsLink() {
      return `/objednavky/set_event_session?event_id=${this.id}&repayments=true`;
    },
  },
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>

<i18n>
{
  "cs": {
    "course": "Kurz",
    "online": "Online",
    "or": "nebo",
    "duration": "Délka",
    "days_duration": ["den", "dny", "dní"],
    "hours_duration": ["hodina", "hodiny", "hodin"],
    "i_am_interested": "Mám zájem",
    "language": "Jazyk",
    "language_translation": {
      "cs": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    },
    "link_to_info_page": "/online-kurzy-virtual-training-vs-elearning",
    "place": "Místo",
    "virtual": "Virtuálně",
    "price_without_vat": "Cena bez DPH",
    "repayments": "S odloženou splatností",
    "term": "Termín"
  },
  "sk": {
    "course": "Kurz",
    "online": "Online",
    "or": "alebo",
    "duration": "Dĺžka",
    "days_duration": ["deň", "dni", "dní"],
    "hours_duration": ["hodina", "hodiny", "hodín"],
    "i_am_interested": "Mám záujem",
    "language": "Jazyk",
    "virtual": "Virtuálne",
    "language_translation": {
      "cs": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    },
    "link_to_info_page": "/online-kurzy",
    "place": "Miesto",
    "price_without_vat": "Cena bez DPH",
    "repayments": "Žiadosť o odloženie splatnosti",
    "term": "Termín"
  },
  "en": {
    "course": "Course",
    "online": "Online",
    "or": "or",
    "duration": "Duration",
    "days_duration": ["day", "days", "days"],
    "hours_duration": ["hour", "hours", "hours"],
    "i_am_interested": "Book",
    "language": "Language",
    "virtual": "Virtual",
    "language_translation": {
      "cs": "Czech",
      "en": "English",
      "sk": "Slovak"
    },
    "link_to_info_page": "/en/live-online-courses",
    "place": "Location",
    "price_without_vat": "Price without VAT",
    "repayments": "Pay later",
    "term": "Date"
  }
}
</i18n>
